// extracted by mini-css-extract-plugin
module.exports = {"showMoreOverlay":"QWK2hry","showMoreLabel":"Ta2CjoF"};